<template>
    <div>
        <Layout
            :header="{ text: '視訊作業', backBtn: { visible: true }, closeBtn: { visible: true, to: { name: routeName.CLOUD_E_COUNTER_RESERVE_HOME } }, }">

            <div class="pt-2 pb-6">
                <Process :steps="['服務條款', '查看內容', '視訊驗證', '身份認證',]" :index="2"></Process>
            </div>

            <div class="pb-4">
                <h2 class="font-bold text-2xl pb-2">
                    視訊驗證
                </h2>
                <p>請先輸入邀請碼，再點選發送邀請碼輸入動態密碼</p>
            </div>

            <div class="pb-4">
                <h3 class="font-bold text-xl pb-2">輸入邀請碼</h3>
                <input type="text" placeholder="請輸入邀請碼" v-model="userData.meetCode"
                    :disabled="pageData.checkMeetCode" />
            </div>

            <div class="pb-4">

                <VerificationCode
                    :buttonDisabled="userData.meetCode === '' || pageData.counting || pageData.sendTimes >= 3"
                    :beginCounting="beginCounting" :stopCounting="stopCounting">
                    <span class="flex justify-between items-center pb-2">
                        <div class="flex pr-1 flex-shrink-0">
                            <p class="text-lg" v-if="pageData.otpCodePre">{{ pageData.otpCodePre }} -</p>
                        </div>
                        <input type="text" placeholder="請輸入 6 碼動態密碼" maxlength="6" size="6"
                            :disabled="userData.meetCode === '' || !pageData.checkMeetCode"
                            v-model="userData.otpCode" />
                    </span>
                </VerificationCode>
            </div>

            <template v-slot:bottom>
                <button
                    class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                    :disabled="userData.meetCode === '' || userData.otpCode === ''" @click="goNextPage">確認
                </button>
            </template>

        </Layout>
        <Loading :is-loading="pageData.isLoading" />
    </div>
</template>
<script setup>
import router from '@/router';
import routeName from '@/router/constant';
import { getInfoOTP, postResentOTP, postSentOTP, postVerifyOTP } from '@/apis/OTP';
import { onMounted, reactive, watch } from 'vue';
import { postCheckMeet } from '@/apis/CloudECounterReserve';
import dialogContnet from '@/views/OTP/dialogContent';
import { notification } from '@/utils/notification';
import Loading from '@/components/Loading.vue';
import '@/assets/cloudCounter/css/style.css';
import Layout from '@/components/cloudCounter/Layout.vue';
import Process from '@/components/cloudCounter/Process.vue';
import VerificationCode from '@/components/cloudCounter/VerificationCode2.vue';
import { openPopup, openPopupCatchMessage } from '@/utils/vfmUtils';

const pageData = reactive({
    isLoading: false,
    mobile: '',
    checkMeetCode: false,
    counting: false,
    sendTimes: 0,
    otpMsg: '',
    otpCodePre: '',
});

const userData = reactive({
    otpCode: '',
    meetCode: '',
});

const goNextPage = () => {
    if (!userData.otpCode) {
        openPopup('動態密碼未輸入，請確認！');
        return;
    }
    pageData.isLoading = true;
    postVerifyOTP(userData.otpCode, pageData.mobile).then(res => {
        const {
            verify,
            cancelTransaction,
            errorTimes,
        } = res.data;
        pageData.verifyErrorTimes = errorTimes;
        if (verify) {
            router.push({
                name: routeName.CLOUD_E_COUNTER_RESERVE_IDENTITY_RECOGNITION,
            });
        } else if (cancelTransaction) {
            openPopup(dialogContnet.otpError5Times.content, () => {
                pageData.isLoading = true;
                window.location = process.env.VUE_APP_CUSTOMER_SERVICE_RUL;
            });
        } else {
            notification({
                title: '驗證失敗',
                text: '驗證碼錯誤',
            });
        }
        setTimeout(() => {
            pageData.isLoading = false;
        }, 1000);
    }).finally(() => {
        pageData.isLoading = false;
    });
};

const beginCounting = () => {
    return new Promise((resolve, reject) => {
        pageData.isLoading = true;
        if (!pageData.checkMeetCode) {
            const request = {
                meetCode: userData.meetCode,
            };
            postCheckMeet(request).then(res => {
                pageData.checkMeetCode = true;
                postSentOTP(false, pageData.mobile).then(res => {
                    pageData.otpCodePre = res?.data?.otpCodePre;
                }).catch(ex => {
                    pageData.otpCodePre = ex?.data?.otpCodePre;
                });
                setTimeout(() => {
                    pageData.counting = true;
                    pageData.isLoading = false;
                    resolve(true);
                }, 3000);
            }).catch(ex => {
                pageData.isLoading = false;
                openPopupCatchMessage(ex);
                reject(false);
            });
        } else {
            postResentOTP().then(res => {
                pageData.otpCodePre = res?.data?.otpCodePre;
                pageData.verifyErrorTimes = 0;
                pageData.sendTimes = res.data.resendTimes;
                if (pageData.sendTimes >= 3) {
                    pageData.otpMsg = '動態密碼重新發送已達三次，請輸入正確動態密碼，謝謝！';
                    openPopup('動態密碼重新發送已達三次，請輸入正確動態密碼，謝謝！');
                }
            }).catch(ex => {
                pageData.otpCodePre = ex?.data?.otpCodePre;
                pageData.sendTimes = ex?.data?.resendTimes;
                if (pageData.sendTimes >= 3) {
                    pageData.otpMsg = '動態密碼重新發送已達三次，請輸入正確動態密碼，謝謝！';
                    openPopup('動態密碼重新發送已達三次，請輸入正確動態密碼，謝謝！');
                }
            });
            setTimeout(() => {
                pageData.counting = true;
                pageData.isLoading = false;
                resolve(true);
            }, 3000);
        }
    });
};
const stopCounting = () => {
    pageData.counting = false;
};
const init = () => {
    getInfoOTP().then((res) => {
        pageData.mobile = res.data.mobile;
    }).catch(ex => {
        openPopup(ex);
    }).finally(() => {
        pageData.isLoading = false;
    });
};
onMounted(() => {
    init();
});
</script>

<style lang="scss" scoped>
.OTP-disabled-btn {
    @apply bg-gray-50 border-gray-200 text-gray-200;
}
</style>
